<!-- Overlay loading -->
<app-fullscreen-overlay
  [isOverlayLoading]="isOverlayLoading"
></app-fullscreen-overlay>

<div class="case-card d-flex flex-column flex-column-fluid">
  <div class="container-fluid">
    <!-- Patient Header Informations -->
    <div class="container-fluid">
      <div class="row">
        <div class="col">
          <div class="container-fluid mt-1 px-0">
            <div class="card">
              <div class="container-fluid pb-4">
                <div class="row align-items-center py-3 pb-0">
                  <div class="col-md-4 pb-2 pt-4">
                    <div class="card-subtitle fw-medium">
                      <span class="fw-bold">
                        {{ caseDetailHeader?.name || "-" }}
                        {{ caseDetailHeader?.lastName || "-" }},
                        {{ caseDetailHeader?.age }},
                        {{ caseDetailHeader?.gender[0] || "-" }},
                        <span class="badge badge-light-success"
                          >{{ "dermNo" | translate }}:
                          {{ caseDetailHeader?.pidNo || "-" }}</span
                        >
                      </span>
                      <p
                        *ngIf="isAppointmentPatient"
                        class="text-gray-600 mb-0 mt-1 fs-12"
                      >
                        {{ "appointmentDate" | translate }}:
                        {{
                          caseDetailHeader?.selectedDateTime
                            | date : "dd-MM-yyyy, HH:mm"
                        }}
                      </p>
                    </div>
                  </div>
                </div>
                <div class="d-flex align-items-center gap-4">
                  <div class="card-subtitle fw-normal">
                    <span class="gray-font fs-14">
                      {{ generalAppearanceTextHeader() }}
                    </span>
                  </div>
                  <div class="card-subtitle fw-medium">
                    <span class="gray-font fs-14">
                      {{ skinTypeTextHeader() }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container-fluid mt-3">
      <div class="row">
        <!-- Patient Informations -->
        <div class="col-md-12 patient-informations">
          <div class="p-3 border card card-height">
            <div class="px-5">
              <!-- Preparation Tabs -->
              <ul
                class="nav nav-tabs nav-line-tabs nav-line-tabs-2x mb-5 fs-6"
                role="tablist"
              >
                <li class="nav-item" role="presentation">
                  <a
                    class="nav-link text-gray-800 fs-14"
                    data-bs-toggle="tab"
                    href="#patient-information-content"
                    aria-selected="false"
                    tabindex="-1"
                    role="tab"
                  >
                    <span
                      class="me-2"
                      style="padding: 0.25rem 0.85rem !important"
                      >1</span
                    >
                    {{ "patientInformation" | translate }}</a
                  >
                </li>
                <li
                  class="nav-item"
                  role="presentation"
                  [ngClass]="{ disabled: !patientInformationForm.valid }"
                >
                  <a
                    (click)="goToOtherTab('medical-history')"
                    class="nav-link text-gray-800 fs-14"
                    data-bs-toggle="tab"
                    href="#medical-history"
                    aria-selected="true"
                    tabindex="-1"
                    role="tab"
                  >
                    <span class="me-2">2</span>
                    {{ "prepMedicalHistoryTab" | translate }}</a
                  >
                </li>
                <li
                  class="nav-item"
                  role="presentation"
                  [ngClass]="{ disabled: !patientInformationForm.valid }"
                >
                  <a
                    (click)="goToOtherTab('medications')"
                    class="nav-link text-gray-800 active fs-14"
                    data-bs-toggle="tab"
                    href="#medications"
                    aria-selected="false"
                    tabindex="-1"
                    role="tab"
                  >
                    <span class="me-2">3</span>
                    {{ "medications" | translate }}</a
                  >
                </li>
              </ul>
              <div class="tab-content" id="nav-tabContent">
                <!-- Patient Information Content -->
                <div
                  class="tab-pane fade"
                  id="patient-information-content"
                  role="tabpanel"
                  aria-labelledby="patient-information-content-tab"
                  tabindex="0"
                >
                  <form
                    [formGroup]="patientInformationForm"
                    id="contactForm"
                    data-sb-form-api-token="API_TOKEN"
                  >
                    <!-- Patient Informations -->
                    <div class="row g-2 mb-3 mt-3">
                      <!-- First Name  -->
                      <div class="col-md-6">
                        <div class="form-floating">
                          <input
                            formControlName="name"
                            class="form-control"
                            id="inputFirstName"
                            type="text"
                            placeholder="John Doe"
                            (blur)="checkNameLastnameBirthDateExists()"
                            (input)="preventForbiddenCharacters($event, 'text')"
                          />
                          <label for="inputFirstName"
                            >*{{ "firstName" | translate }}</label
                          >
                          <div
                            *ngIf="isControlInvalid('name')"
                            class="text-danger"
                          >
                            <div
                              *ngIf="patientInformationForm.get('name')?.errors?.['required']"
                            >
                              {{ "firstNameIsRequired" | translate }}
                            </div>
                            <div
                              *ngIf="patientInformationForm.get('name')?.errors?.['lettersOnly']"
                            >
                              {{
                                "firstNameMustOnlyContainLetters" | translate
                              }}
                            </div>
                          </div>
                        </div>
                      </div>
                      <!-- Last Name -->
                      <div class="col-md-6">
                        <div class="form-floating">
                          <input
                            formControlName="lastName"
                            class="form-control"
                            id="inputLastName"
                            type="text"
                            placeholder="John Doe"
                            (blur)="checkNameLastnameBirthDateExists()"
                            (input)="preventForbiddenCharacters($event, 'text')"
                          />
                          <label for="inputLastName"
                            >*{{ "lastName" | translate }}</label
                          >
                          <div
                            *ngIf="isControlInvalid('lastName')"
                            class="text-danger"
                          >
                            <div
                              *ngIf="patientInformationForm.get('lastName')?.errors?.['required']"
                            >
                              {{ "lastNameIsRequired" | translate }}
                            </div>
                            <div
                              *ngIf="patientInformationForm.get('lastName')?.errors?.['lettersOnly']"
                            >
                              {{ "lastNameMustOnlyContainLetters" | translate }}
                            </div>
                          </div>
                        </div>
                      </div>
                      <!-- Gender -->
                      <div class="col-md-3">
                        <div class="form-floating">
                          <select
                            formControlName="gender"
                            class="form-select cursor-pointer"
                            id="inputGender"
                            aria-label="Gender"
                          >
                            <option [ngValue]="null" disabled>
                              *{{ "gender" | translate }}
                            </option>
                            <option
                              *ngFor="let gender of genders"
                              [value]="gender.id"
                            >
                              {{ gender.name }}
                            </option>
                          </select>
                          <label for="inputGender">{{
                            "gender" | translate
                          }}</label>
                          <div
                            *ngIf="isControlInvalid('gender')"
                            class="text-danger"
                          >
                            {{ "genderIsRequired" | translate }}
                          </div>
                        </div>
                      </div>
                      <!-- Birth of Date -->
                      <div class="col-md-3">
                        <div class="form-floating">
                          <input
                            formControlName="birthDate"
                            type="text"
                            (ngModelChange)="onDateInputChange($event)"
                            (blur)="onBlurDateInput($event)"
                            class="form-control"
                            id="inputDob"
                            [placeholder]="'dateOfBirth' | translate"
                            [max]="maxDate"
                            maxlength="10"
                            (blur)="checkNameLastnameBirthDateExists()"
                          />
                          <label for="inputDob"
                            >*{{ "dateOfBirth" | translate }}</label
                          >
                          <div
                            *ngIf="isControlInvalid('birthDate')"
                            class="text-danger"
                          >
                            <div
                              *ngIf="patientInformationForm.get('birthDate')?.errors?.['dateFormatInvalid']"
                            >
                              {{ "dateOfBirthIsRequired" | translate }}
                            </div>
                            <div
                              *ngIf="patientInformationForm.get('birthDate')?.errors?.['dateOfBirthMinLength']"
                            >
                              {{ "dateOfBirthFormatIsWrong" | translate }}
                            </div>
                          </div>
                        </div>
                      </div>
                      <!-- Height -->
                      <div class="col-md-3">
                        <div class="form-floating">
                          <input
                            formControlName="height"
                            class="form-control"
                            id="inputHeight"
                            type="tel"
                            placeholder="2784"
                            [min]="0"
                            [max]="300"
                            (input)="
                              preventForbiddenCharacters($event, 'number')
                            "
                          />
                          <label for="inputHeight"
                            >*{{ "height" | translate }} (cm)</label
                          >
                          <div
                            *ngIf="isControlInvalid('height')"
                            class="text-danger"
                          >
                            <div
                              *ngIf="patientInformationForm.get('height')?.errors?.['required']"
                            >
                              {{ "heightIsRequired" | translate }}
                            </div>
                            <div
                              *ngIf="patientInformationForm.get('height')?.errors?.['max']"
                            >
                              {{ "maxHeightMustBe300" | translate }}
                            </div>
                          </div>
                        </div>
                      </div>
                      <!-- Weight -->
                      <div class="col-md-3">
                        <div class="form-floating">
                          <input
                            formControlName="weight"
                            class="form-control"
                            id="inputWeight"
                            type="tel"
                            placeholder="2784"
                            [min]="0"
                            [max]="999"
                            (input)="
                              preventForbiddenCharacters($event, 'number')
                            "
                          />
                          <label for="inputWeight"
                            >*{{ "weight" | translate }} ({{
                              "kg" | translate
                            }})</label
                          >
                          <div
                            *ngIf="isControlInvalid('weight')"
                            class="text-danger"
                          >
                            <div
                              *ngIf="patientInformationForm.get('weight')?.errors?.['required']"
                            >
                              {{ "weightIsRequired" | translate }}
                            </div>
                            <div
                              *ngIf="patientInformationForm.get('weight')?.errors?.['max']"
                            >
                              {{ "maxWeightMustBe1000" | translate }}
                            </div>
                          </div>
                        </div>
                      </div>
                      <!-- Email -->
                      <div class="col-md-6">
                        <div class="form-floating">
                          <input
                            formControlName="email"
                            class="form-control"
                            id="inputEmail"
                            type="email"
                            placeholder="john@amatis.nl"
                            (input)="
                              preventForbiddenCharacters($event, 'email')
                            "
                          />
                          <label for="inputEmail"
                            >*{{ "email" | translate }}</label
                          >
                          <div
                            *ngIf="isControlInvalid('email')"
                            class="text-danger"
                          >
                            <div
                              *ngIf="patientInformationForm.get('email')?.errors?.['required']"
                            >
                              {{ "emailIsRequired" | translate }}
                            </div>
                            <div
                              *ngIf="patientInformationForm.get('email')?.errors?.['email']"
                            >
                              {{ "emailIsNotValid" | translate }}
                            </div>
                          </div>
                        </div>
                      </div>
                      <!-- Telephone Number -->
                      <div class="col-md-6">
                        <div class="form-floating">
                          <input
                            formControlName="phone1"
                            class="form-control"
                            id="inputTel"
                            type="tel"
                            placeholder="12345678"
                            maxlength="15"
                            (input)="preventForbiddenCharacters($event, 'tel')"
                          />
                          <label for="inputTel"
                            >*{{ "telephoneNumber" | translate }}</label
                          >
                          <div
                            *ngIf="isControlInvalid('phone1')"
                            class="text-danger"
                          >
                            <div
                              *ngIf="patientInformationForm.get('phone1')?.errors?.['required']"
                            >
                              {{ "telNoIsRequired" | translate }}
                            </div>
                            <div
                              *ngIf="
                                patientInformationForm.get('phone1')?.errors &&
                                patientInformationForm.get('phone1')?.errors[
                                  'minlength'
                                ]
                              "
                            >
                              {{ "telNoMinFive" | translate }}
                            </div>
                            <div
                              *ngIf="
                                patientInformationForm.get('phone1')?.errors &&
                                patientInformationForm.get('phone1')?.errors[
                                  'maxlength'
                                ]
                              "
                            >
                              {{ "telNoMaxFifteen" | translate }}
                            </div>
                            <div
                              *ngIf="patientInformationForm.get('phone1')?.errors?.['pattern']"
                            >
                              {{ "telNoIsNotValid" | translate }}
                            </div>
                          </div>
                        </div>
                      </div>
                      <!-- Skin Type -->
                      <div class="col-md-12 mt-6">
                        <p class="fw-medium fs-14">
                          *{{ "skinType" | translate }}
                        </p>
                        <hr
                          class="pt-1 mt-0"
                          style="padding-top: 0.15rem !important"
                        />
                        <div class="form-group">
                          <div
                            class="d-flex justify-content-flex-start gap-6"
                            *ngIf="skinTypes?.length"
                          >
                            <div
                              class="text-center"
                              *ngFor="let type of skinTypes; let i = index"
                            >
                              <input
                                class="form-check-input d-block mx-auto cursor-pointer skin-type-input border-0"
                                type="radio"
                                [id]="'skinType' + i"
                                formControlName="skinType"
                                [value]="type.id"
                                [ngStyle]="{
                                  backgroundColor: skinTypeColors[i]
                                }"
                              />
                              <label
                                class="form-check-label d-block mt-2"
                                [for]="'skinType' + i"
                              >
                                {{ type.name }}
                              </label>
                              <p class="desc">{{ type.desc }}</p>
                            </div>
                          </div>
                          <div
                            *ngIf="
                              patientInformationForm.get('skinType')?.invalid &&
                              patientInformationForm.get('skinType')?.touched
                            "
                            class="text-danger mt-2"
                          >
                            {{ "skinTypeIsRequired" | translate }}
                          </div>
                        </div>
                      </div>
                      <!-- General Appearance -->
                      <div class="col-md-12 mt-6">
                        <p class="fw-medium fs-14">
                          {{ "generalAppearance" | translate }}
                        </p>
                        <hr
                          class="pt-1 mt-0"
                          style="padding-top: 0.15rem !important"
                        />
                        <div class="form-check form-check-inline">
                          <input
                            class="form-check-input"
                            type="checkbox"
                            id="frecklesChange"
                            [checked]="freckles"
                            value="freckles"
                            (change)="generalAppearance($event)"
                            [disabled]="isFormElementsEnabled"
                          />
                          <label
                            class="form-check-label text-black"
                            for="frecklesChange"
                            >{{ "freckles" | translate }}</label
                          >
                        </div>
                        <div class="form-check form-check-inline">
                          <input
                            class="form-check-input"
                            type="checkbox"
                            id="redHairChange"
                            [checked]="redHair"
                            value="redHair"
                            (change)="generalAppearance($event)"
                            [disabled]="isFormElementsEnabled"
                          />
                          <label
                            class="form-check-label text-black"
                            for="redHairChange"
                            >{{ "redHair" | translate }}</label
                          >
                        </div>
                        <div class="form-check form-check-inline">
                          <input
                            class="form-check-input"
                            type="checkbox"
                            id="lightColoredEyesChange"
                            [checked]="lightColoredEyes"
                            value="lightColoredEyes"
                            (change)="generalAppearance($event)"
                            [disabled]="isFormElementsEnabled"
                          />
                          <label
                            class="form-check-label text-black"
                            for="lightColoredEyesChange"
                            >{{ "lightColoredEyes" | translate }}</label
                          >
                        </div>
                      </div>
                    </div>
                    <div class="text-end">
                      <button
                        [disabled]="!patientInformationForm.valid"
                        (click)="goToOtherTab('medical-history')"
                        type="submit"
                        class="btn btn-sm btn-primary cursor-pointer"
                      >
                        {{ "nextStep" | translate }}
                      </button>
                    </div>
                  </form>
                </div>
                <!-- Medical History Content -->
                <div
                  class="tab-pane fade"
                  id="medical-history"
                  role="tabpanel"
                  aria-labelledby="medical-history-tab"
                  tabindex="0"
                >
                  <div class="accordion" id="accordionExample">
                    <!-- riskFactors -->
                    <div class="accordion-item">
                      <h2 class="accordion-header" id="headingOne">
                        <button
                          class="accordion-button fw-medium fs-14 cursor-pointer"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapseOne"
                          aria-expanded="true"
                          aria-controls="collapseOne"
                        >
                          {{ "riskFactors" | translate }}
                        </button>
                      </h2>
                      <div
                        id="collapseOne"
                        class="accordion-collapse collapse show"
                        aria-labelledby="headingOne"
                        data-bs-parent="#accordionExample"
                      >
                        <div class="accordion-body">
                          <div
                            class="form-check form-check-inline"
                            *ngFor="
                              let history of medicalHistoryArr.riskFactors
                            "
                          >
                            <input
                              class="form-check-input"
                              type="checkbox"
                              [id]="'riskFactor' + history.id"
                              [value]="history.id"
                              [checked]="isCheckedRisk(history.id)"
                              (change)="
                                onMedicalHistoryChange($event, 'risk-factors')
                              "
                              [disabled]="isFormElementsEnabled"
                            />
                            <label
                              class="form-check-label text-black cursor-pointer"
                              [for]="'riskFactor' + history.id"
                            >
                              {{ history.name }}
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- dermatologicDiseases -->
                    <div class="accordion-item">
                      <h2 class="accordion-header" id="headingTwo">
                        <button
                          class="accordion-button collapsed fw-medium fs-14 cursor-pointer"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapseTwo"
                          aria-expanded="false"
                          aria-controls="collapseTwo"
                        >
                          {{ "dermatologicDiseases" | translate }}
                        </button>
                      </h2>
                      <div
                        id="collapseTwo"
                        class="accordion-collapse collapse"
                        aria-labelledby="headingTwo"
                        data-bs-parent="#accordionExample"
                      >
                        <div class="accordion-body">
                          <div
                            class="form-check form-check-inline"
                            *ngFor="
                              let history of medicalHistoryArr.dermatologicDiseases
                            "
                          >
                            <input
                              class="form-check-input"
                              type="checkbox"
                              [id]="'dermatologic-diseases' + history.id"
                              [value]="history.id"
                              [checked]="
                                isCheckedDermatologicDiseases(history.id)
                              "
                              (change)="
                                onMedicalHistoryChange(
                                  $event,
                                  'dermatologic-diseases'
                                )
                              "
                              [disabled]="isFormElementsEnabled"
                            />
                            <label
                              class="form-check-label text-black cursor-pointer"
                              [for]="'dermatologic-diseases' + history.id"
                            >
                              {{ history.name }}
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- neoplasticDiseases -->
                    <div class="accordion-item">
                      <h2 class="accordion-header" id="headingThree">
                        <button
                          class="accordion-button collapsed fw-medium fs-14 cursor-pointer"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapseThree"
                          aria-expanded="false"
                          aria-controls="collapseThree"
                        >
                          {{ "neoplasticDiseases" | translate }}
                        </button>
                      </h2>
                      <div
                        id="collapseThree"
                        class="accordion-collapse collapse"
                        aria-labelledby="headingThree"
                        data-bs-parent="#accordionExample"
                      >
                        <div class="accordion-body">
                          <div
                            class="form-check form-check-inline"
                            *ngFor="
                              let history of medicalHistoryArr.neoplasticDiseases
                            "
                          >
                            <input
                              class="form-check-input"
                              type="checkbox"
                              [id]="'neoplastic-diseases' + history.id"
                              [value]="history.id"
                              [checked]="
                                isCheckedNeoplasticDiseases(history.id)
                              "
                              (change)="
                                onMedicalHistoryChange(
                                  $event,
                                  'neoplastic-diseases'
                                )
                              "
                              [disabled]="isFormElementsEnabled"
                            />
                            <label
                              class="form-check-label text-black cursor-pointer"
                              [for]="'neoplastic-diseases' + history.id"
                            >
                              {{ history.name }}
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- diseasesCausingImmunosuppression -->
                    <div class="accordion-item">
                      <h2 class="accordion-header" id="headingFour">
                        <button
                          class="accordion-button collapsed fw-medium fs-14 cursor-pointer"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapseFour"
                          aria-expanded="false"
                          aria-controls="collapseFour"
                        >
                          {{ "diseasesCausingImmunosuppression" | translate }}
                        </button>
                      </h2>
                      <div
                        id="collapseFour"
                        class="accordion-collapse collapse"
                        aria-labelledby="headingFour"
                        data-bs-parent="#accordionExample"
                      >
                        <div class="accordion-body">
                          <div
                            class="form-check form-check-inline"
                            *ngFor="
                              let history of medicalHistoryArr.diseaseCousingImmunosuppressions
                            "
                          >
                            <input
                              class="form-check-input"
                              type="checkbox"
                              [checked]="
                                isCheckedDiseaseCousingImmunosuppressions(
                                  history.id
                                )
                              "
                              [id]="
                                'diseases-causing-immunosuppression' +
                                history.id
                              "
                              [value]="history.id"
                              (change)="
                                onMedicalHistoryChange(
                                  $event,
                                  'diseases-causing-immunosuppression'
                                )
                              "
                              [disabled]="isFormElementsEnabled"
                            />
                            <label
                              class="form-check-label text-black cursor-pointer"
                              [for]="
                                'diseases-causing-immunosuppression' +
                                history.id
                              "
                            >
                              {{ history.name }}
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- otherDiseases-->
                    <div class="accordion-item">
                      <h2 class="accordion-header" id="headingFive">
                        <button
                          class="accordion-button collapsed fw-medium fs-14 cursor-pointer"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapseFive"
                          aria-expanded="false"
                          aria-controls="collapseFive"
                        >
                          {{ "otherDiseases" | translate }}
                        </button>
                      </h2>
                      <div
                        id="collapseFive"
                        class="accordion-collapse collapse"
                        aria-labelledby="headingFive"
                        data-bs-parent="#accordionExample"
                      >
                        <div class="accordion-body">
                          <div
                            class="form-check form-check-inline"
                            *ngFor="
                              let history of medicalHistoryArr.otherDiseases
                            "
                          >
                            <input
                              class="form-check-input"
                              type="checkbox"
                              [id]="'other-diseases' + history.id"
                              [value]="history.id"
                              [checked]="isCheckedOtherDiseases(history.id)"
                              (change)="
                                onMedicalHistoryChange($event, 'other-diseases')
                              "
                              [disabled]="isFormElementsEnabled"
                            />
                            <label
                              class="form-check-label text-black cursor-pointer"
                              [for]="'other-diseases' + history.id"
                            >
                              {{ history.name }}
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="text-end mt-6">
                    <button
                      [disabled]="!patientInformationForm.valid"
                      (click)="goToOtherTab('medications')"
                      type="button"
                      class="btn btn-sm btn-primary cursor-pointer"
                    >
                      {{ "nextStep" | translate }}
                    </button>
                  </div>
                </div>
                <!-- Medications Content -->
                <div
                  class="tab-pane fade show active"
                  id="medications"
                  role="tabpanel"
                  aria-labelledby="medications-tab"
                  tabindex="0"
                >
                  <!-- Medications -->
                  <div class="medications">
                    <div class="d-flex flex-wrap gap-4">
                      <div
                        class="form-check form-check-inline"
                        style="margin-bottom: -7px !important"
                        *ngFor="let history of medicalHistoryArr.medications"
                      >
                        <input
                          class="form-check-input"
                          type="checkbox"
                          [id]="'medications' + history.id"
                          [value]="history.id"
                          [checked]="isCheckedMedicationsIds(history.id)"
                          (change)="
                            onMedicalHistoryChange($event, 'medications')
                          "
                          [disabled]="isFormElementsEnabled"
                        />
                        <label
                          class="form-check-label text-black"
                          [for]="'medications' + history.id"
                        >
                          {{ history.name }}
                        </label>
                      </div>
                    </div>
                  </div>

                  <div *ngIf="showSaveAndTakePicture" class="text-end mt-8">
                    <button
                      (click)="saveAndTakePicture($event)"
                      type="button"
                      class="btn btn-sm btn-dark"
                      [ngClass]="{
                        'btn-secondary': isSaveButtonDisable(),
                        'btn-dark': !isSaveButtonDisable()
                      }"
                      [disabled]="isSaveButtonDisable()"
                    >
                      {{ "saveAndTakePicture" | translate }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <button class="fullscreen-button me-3">
              <i class="fa-solid fa-expand"></i>
            </button>
          </div>
        </div>
        <!-- Lesion Characteristics -->
        <!-- <div class="col-md-6">
          <div class="p-3 border card card-height pb-0">
            <div class="container px-5">
              <ul
                class="nav nav-tabs nav-line-tabs nav-line-tabs-2x mb-5 fs-6"
                role="tablist"
              >
                <li class="nav-item" role="presentation">
                  <a
                    class="nav-link lesion-nav-link text-gray-800 fs-14"
                    data-bs-toggle="tab"
                    href="#lesion-characteristics-content"
                    aria-selected="true"
                    tabindex="-1"
                    role="tab"
                    >{{ "lesionCharacteristics" | translate }}</a
                  >
                </li>
              </ul>
              <div class="tab-content" id="nav-tabContent">
                <div
                  id="patient-information-content"
                  role="tabpanel"
                  aria-labelledby="patient-information-content-tab"
                  tabindex="0"
                >
                  <form
                    [formGroup]="lesionCharacteristicsForm"
                    (ngSubmit)="saveAndTakePicture($event)"
                    id="contactForm"
                    data-sb-form-api-token="API_TOKEN"
                  >
                    <div class="col-md-12 mt-8">
                      <p class="fw-medium mb-3 fs-14">
                        {{ "complaints" | translate }}
                      </p>
                      <div class="form-check form-check-inline">
                        <input
                          class="form-check-input"
                          type="checkbox"
                          id="itchingChangeComplaint"
                          value="itching"
                          (change)="generalComplaint($event)"
                          [disabled]="isFormElementsEnabled"
                        />
                        <label
                          class="form-check-label text-black"
                          for="itchingChangeComplaint"
                          >{{ "itching" | translate }}</label
                        >
                      </div>
                      <div class="form-check form-check-inline">
                        <input
                          class="form-check-input"
                          type="checkbox"
                          id="painChangeComplaint"
                          value="pain"
                          (change)="generalComplaint($event)"
                          [disabled]="isFormElementsEnabled"
                        />
                        <label
                          class="form-check-label text-black"
                          for="painChangeComplaint"
                          >{{ "pain" | translate }}</label
                        >
                      </div>
                      <div class="form-check form-check-inline">
                        <input
                          class="form-check-input"
                          type="checkbox"
                          id="bleedingChangeComplaint"
                          value="bleeding"
                          (change)="generalComplaint($event)"
                          [disabled]="isFormElementsEnabled"
                        />
                        <label
                          class="form-check-label text-black"
                          for="bleedingChangeComplaint"
                          >{{ "bleeding" | translate }}</label
                        >
                      </div>
                      <div class="form-check form-check-inline">
                        <input
                          class="form-check-input"
                          type="checkbox"
                          id="ulcerationChangeComplaint"
                          value="ulceration"
                          (change)="generalComplaint($event)"
                          [disabled]="isFormElementsEnabled"
                        />
                        <label
                          class="form-check-label text-black"
                          for="ulcerationChangeComplaint"
                          >{{ "ulceration" | translate }}</label
                        >
                      </div>
                    </div>
                    <div class="col-md-12 mt-2">
                      <p class="fw-medium mb-0 fs-14">
                        {{ "since" | translate }}
                      </p>
                      <div class="row align-items-center gap-6">
                        <div class="col-md-2">
                          <div class="form-check form-check-inline">
                            <input
                              class="form-check-input"
                              type="checkbox"
                              id="sinceChange"
                              value="congenital"
                              (change)="sinceCheckbox($event)"
                              [disabled]="isFormElementsEnabled"
                            />
                            <label
                              class="form-check-label text-black"
                              for="sinceChange"
                              >{{ "congenital" | translate }}</label
                            >
                          </div>
                        </div>
                        <div class="col-md-5">
                          <div class="row align-items-center">
                            <div class="col-md-4">
                              <div class="form-floating">
                                <input
                                  formControlName="customCongenitalValue"
                                  class="form-control"
                                  id="inputWeek"
                                  type="tel"
                                  placeholder="1"
                                  [min]="1"
                                  [max]="300"
                                  (input)="preventNegativeInput($event, 300)"
                                  (blur)="setInputAfterBlur($event)"
                                />
                                <label for="inputWeek">{{
                                  "week" | translate
                                }}</label>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-12 mt-2">
                      <p class="fw-medium mb-3 fs-14">
                        {{ "change" | translate }}
                      </p>
                      <div class="form-check form-check-inline">
                        <input
                          class="form-check-input"
                          type="checkbox"
                          id="sizeChange"
                          value="size"
                          (change)="changeCheckbox($event)"
                          [disabled]="isFormElementsEnabled"
                        />
                        <label
                          class="form-check-label text-black"
                          for="sizeChange"
                          >{{ "size" | translate }}</label
                        >
                      </div>
                      <div
                        *ngIf="selectedChangeItems.includes('size')"
                        class="form-check form-check-inline"
                      >
                        <input
                          class="form-check-input"
                          type="checkbox"
                          id="6mmChange"
                          value="sixmm"
                          (change)="changeCheckbox($event)"
                          [disabled]="isFormElementsEnabled"
                        />
                        <label
                          class="form-check-label text-black"
                          for="6mmChange"
                          >>{{ "6mm" | translate }}</label
                        >
                      </div>
                      <div class="form-check form-check-inline">
                        <input
                          class="form-check-input"
                          type="checkbox"
                          id="borderChange"
                          value="border"
                          (change)="changeCheckbox($event)"
                          [disabled]="isFormElementsEnabled"
                        />
                        <label
                          class="form-check-label text-black"
                          for="borderChange"
                          >{{ "border" | translate }}</label
                        >
                      </div>
                      <div class="form-check form-check-inline">
                        <input
                          class="form-check-input"
                          type="checkbox"
                          id="colorChange"
                          value="color"
                          (change)="changeCheckbox($event)"
                          [disabled]="isFormElementsEnabled"
                        />
                        <label
                          class="form-check-label text-black"
                          for="colorChange"
                          >{{ "color" | translate }}</label
                        >
                      </div>
                    </div>

                    <div *ngIf="showSaveAndTakePicture" class="text-end mt-8">
                      <button
                        type="submit"
                        class="btn btn-sm btn-dark"
                        [ngClass]="{
                          'btn-secondary': isSaveButtonDisable(),
                          'btn-dark': !isSaveButtonDisable()
                        }"
                        [disabled]="isSaveButtonDisable()"
                      >
                        {{ "saveAndTakePicture" | translate }}
                      </button>
                    </div>
                  </form>
                </div>

                <div class="row g-3 mt-4">
                  <div class="col-12">
                    <div class="row g-2">
                      <div
                        *ngFor="let image of caseImages; let i = index"
                        class="col-md-3"
                      >
                        <div class="img-square">
                          <img
                            [src]="image.src"
                            class="img-fluid rounded img-thumbnail border-0"
                            [alt]="image.alt"
                            style="width: 100%; height: auto; object-fit: cover"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  *ngFor="let image of caseImages"
                  class="modal fade"
                  [id]="image.id"
                  tabindex="-1"
                  aria-labelledby="imageModalLabel"
                  aria-hidden="true"
                >
                  <div class="modal-dialog modal-xl">
                    <div class="modal-content">
                      <div class="modal-header">
                        <h5 class="modal-title" id="imageModalLabel">
                          {{ "skinPreview" | translate }}
                        </h5>
                        <button
                          type="button"
                          class="btn-close cursor-pointer"
                          data-bs-dismiss="modal"
                          aria-label="Close"
                        ></button>
                      </div>
                      <div class="modal-body text-center pt-0">
                        <img
                          [src]="image.src"
                          id="modalImage"
                          class="img-fluid"
                          width="65%"
                          alt="Responsive image"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div> -->
      </div>
    </div>
    <!-- Timelines -->
    <!-- <div *ngIf="caseId?.length" class="container-fluid mt-2">
      <div class="row">
        <div class="col">
          <div class="container-fluid mt-1 ps-0">
            <div class="card">
              <div class="container-fluid">
                <div class="row">
                  <div class="card-header border-0 pt-5">
                    <h3 class="card-title align-items-start flex-column">
                      <span class="card-label mb-1">{{
                        "consultationTimeLine" | translate
                      }}</span>
                    </h3>
                  </div>
                  <div class="container">
                    <div class="time-line">
                      <div *ngIf="caseTimelineList && caseTimelineList?.length">
                        <div
                          *ngFor="
                            let timeline of caseTimelineList;
                            let i = index
                          "
                          class="time-line-item"
                          [class.selected-item]="selectedIndex === i"
                          (click)="selectItem(i, timeline)"
                        >
                          <div class="time-line-dot"></div>
                          <h4 class="card-label fw-medium">
                            {{
                              timeline?.createdDate
                                ? (timeline?.createdDate | date : "dd-MM-yyyy")
                                : "-"
                            }}
                          </h4>
                        </div>
                      </div>
                      <div
                        class="time-line-item today"
                        [class.selected-item]="
                          selectedIndex === caseTimelineList.length
                        "
                        (click)="
                          selectItem(caseTimelineList.length, { isToday: true })
                        "
                      >
                        <div class="time-line-dot"></div>
                        <h4 class="card-label fw-medium">
                          {{ today | date : "dd-MM-yyyy" }}
                        </h4>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div> -->
  </div>
</div>

<!-- Waiting Modal -->
<div
  class="modal fade"
  id="waitingModalModal"
  data-bs-backdrop="static"
  data-bs-keyboard="false"
  tabindex="-1"
  aria-labelledby="waitingModalLabel"
  aria-hidden="true"
  #waitingModalModal
>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-body">
        <p class="fs-6">
          {{
            "pleaseTakeTheImageOnTheMobileAndWaitUntilItsUploaded" | translate
          }}
        </p>
        <div class="d-flex align-items-center justify-content-center mb-6">
          <div class="text-primary text-center" *ngIf="qrCodeDetails?.url">
            <img alt="qrcode" [src]="qrCodeDetails.url" class="h-170" />
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Name, Lastname and Birth Date Validation Error Modal -->
<div
  class="modal fade"
  id="nameLastnameBirthDateValidationErrorModal"
  data-bs-backdrop="static"
  data-bs-keyboard="false"
  tabindex="-1"
  aria-labelledby="nameLastnameBirthDateValidationErrorLabel"
  aria-hidden="true"
  #nameLastnameBirthDateValidationErrorModal
>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-body">
        <p class="fs-6 text-center">
          {{ "errorNameLastnameBirthDateValidatorDesc" | translate }}
        </p>
      </div>

      <div class="container-fluid ai-analysis-button pb-3">
        <div class="row">
          <div class="col text-end modal-buttons-area">
            <button
              type="button"
              class="btn btn-secondary cursor-pointer"
              data-bs-toggle="modal"
              (click)="closeNameLastnameBirthDateValidationErrorModal('no')"
            >
              {{ "no" | translate }}
            </button>
            <button
              type="button"
              class="btn btn-primary cursor-pointer"
              data-bs-toggle="modal"
              (click)="closeNameLastnameBirthDateValidationErrorModal('yes')"
            >
              {{ "yes" | translate }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
